enum CompletenessScoreType {
    SUFFICIENT,
    GOOD,
    VERY_GOOD,
    EXCELLENT,
}

export default CompletenessScoreType;